import Vue from 'vue';
export default Vue.extend({
    name: 'commonVideo',
    props: {
        href: {
            type: String,
            default: 'javascript:void(0)',
        },
    },
    data: function () {
        return {
            showText: '观看教程',
            dialogVisible: false,
        };
    },
    methods: {
        playVideo: function () {
            this.dialogVisible = true;
        },
    },
    watch: {
        dialogVisible: function (val) {
            !val && document.getElementById('video-control').pause();
        },
    },
});
